import React, { useState } from 'react';
import {Icon, Title } from '../../../components/components';
import { useTranslation } from 'react-i18next';
import {Button, Modal, Row} from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useCreateAwsCredMutation, useGetAwsCredsQuery, useDeleteAwsCredMutation } from '../../../api/awsCredsApiSlice';
import AwsCredsTable from '../../../components/aws_creds/AwsCredsTable';


function AwsCredentials() {
	const { t } = useTranslation();
	const [ newCreds, setNewCreds] = useState({});
	const [ showCreateModal, setShowCreateModal ] = useState(false);
  const { data: credsList, isSuccess, refetch } = useGetAwsCredsQuery()
  const [ createCred ] = useCreateAwsCredMutation()
  const [ deleteCred ] = useDeleteAwsCredMutation()

	const deleteAwsCred = async (id) => {
    await deleteCred(id)
    refetch()
  };

  const createAwsCred = async () => {
    await createCred()
    refetch()
	};

	const newAwsCred = () => {
		if (credsList.length < 2) {
			createAwsCred()
		} else {
      setShowCreateModal(true)
    }
	};

	const credsModal = () => {
		if (newCreds["aws_access_key"]) {
			let showModal = true;
			return (
				<Modal backdrop="static" show={showModal} onHide={()=>{setNewCreds({}); showModal=false}}>
					<Modal.Header closeButton>
						<Modal.Title>{t("awsCredentials.creds")}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<p><em>Access key : </em>{newCreds["aws_access_key"]}</p>
						<p><em>Access secret : </em>{newCreds["aws_secret_access_key"]}</p>
					</Modal.Body>
				</Modal>
			)
		}
	};

  if( !isSuccess ) { return (<></>) }
	return (
		<>
      <Title main={t("menu.organisation")} sub={t("menu.awsCredentials")} group={false}>
        <Button variant='primary' onClick={newAwsCred}>
          <Icon icon='plus' text={t("awsCredentials.new")} />
        </Button>
      </Title>
      { showCreateModal && <SweetAlert warning
                  title={t("awsCredentials.createAlert.title")}
                  confirmBtnText={"OK"}
                  confirmBtnBsStyle="warning"
                  onConfirm={() => setShowCreateModal(false)}
      >
        {t("awsCredentials.createAlert.text")}
      </SweetAlert>}
      {credsModal()}
      <AwsCredsTable creds={credsList} onDelete={(cell) => (deleteAwsCred(cell.value))}/>
		</>
	)
}

export default AwsCredentials
